$(function(){
    $('.add-thumbnail').on('click', function(){
        $('input[name="thumbnail"]').trigger('click');
    });


    $('.regional-chapter').on('click', function () {
        var chapter = $(this).data('chapter');
        var displayText = $(this).data('chapter-text');

        $('#regional-chapter-header').text(displayText);

        modalRegionalChapter(chapter);

    });
    
    function modalRegionalChapter(chapter) 
    {
        var url = "/regional-chapters/page-load/chapter";
    
        $("#chapter-board-content").load(url + "?region=" + chapter, function() {
    
        });
    
        $('#chapter-board-modal').modal('show');
    }

    function readURL(input) {

        if (input.files && input.files[0]) {
        var reader = new FileReader();
    
        reader.onload = function(e) {
            $('.thumbnail').css('background-image', 'url("' + e.target.result + '")');
            // .css("background-image", "url('/css/images/css.jpg')");
        }
    
        reader.readAsDataURL(input.files[0]);
        }
    }

    $('input[name="thumbnail"]').change(function() {
        readURL(this);
    });

    $(function() {
        $('#mdlSuccess').modal('show');

        $('.clickable-thumbnail').on('click', function () {
            var href = $(this).closest('.card-body').find('.link').attr('href');
            window.location.href = href;
        });
    });

    // password
    $('.password').keypress(function(e){
        if(e.which === 32){
            customAlert('<p>Sorry, space is not allowed for password.</p>');
            return false;
        }
    });

    // password input
    var passwordError = 0;
    function checkPassword(password, requirement, condition){
        if ( password.match(condition) ) {
            requirement.removeClass('text-danger').addClass('text-success');
            requirement.find('small .fas').removeClass('fa-times-circle').addClass('fa-check-circle');
        } else {
            passwordError++;
            requirement.removeClass('text-success').addClass('text-danger');
            requirement.find('small .fas').removeClass('fa-check-circle').addClass('fa-times-circle');
        }
    }
    $('input[name="password"]').keyup(function() {
        var password = $('input[name="password"]').val();
        passwordError = 0;
        
        // validate length
        if ( password.length < 6 ) {
            $('#length').removeClass('text-success').addClass('text-danger');
            $('#length').find('small .fas').removeClass('fa-check-circle').addClass('fa-times-circle');
            passwordError++;
        } else {
            $('#length').removeClass('text-danger').addClass('text-success');
            $('#length').find('small .fas').removeClass('fa-times-circle').addClass('fa-check-circle');
        }

        //validate number
        checkPassword(password, $('#number'), /\d/);

        //validate letter
        checkPassword(password, $('#letter'), /[A-z]/);
        
        // validate capital letter
        checkPassword(password, $('#capital'), /[A-Z]+/);
        
        if(passwordError == 0){
            $('#validPassword').removeClass('d-none');
            $('#invalidPassword').addClass('d-none');
        }
        else{
            $('#validPassword').addClass('d-none');
            $('#invalidPassword').removeClass('d-none');
        }
        $('input[name="verifypassword"]').val('');
        $('#matchedPassword').addClass('d-none');
        $('#unmatchedPassword').addClass('d-none');
    });
    $('input[name="password"]').focus(function() {
        $('.passwordRequirements').removeClass('d-none');
    });
    $('input[name="password"]').blur(function() {
        $('.passwordRequirements').addClass('d-none');
    });
    $('input[name="verifypassword"]').keyup(function(){
        if($(this).val() == $('input[name="password"]').val()){
            $('#matchedPassword').removeClass('d-none');
            $('#unmatchedPassword').addClass('d-none');
        }
        else{
            $('#matchedPassword').addClass('d-none');
            $('#unmatchedPassword').removeClass('d-none');
        }
    });

    function verifyPassword(a, b, e){
        if(a != b){
            e.preventDefault();
            customAlert('Please make sure your password is valid and matched. <br>');
        }
    }
    $('.place-order').on('click', function(e){
        var a = $('input[name="password"]').val();
        var b = $('input[name="verifypassword"]').val();
        verifyPassword(a, b, e);
    });
    function customAlert(message){
        $('.alertMessage').html(message);
        $('#alertModal').modal('show')
    }

    // payment modal
    $('#automodal').modal('show');

    // error modal
    $('#errorModal').modal('show');

    // success modal
    $('#successModal').modal('show');

    // disable registration
    $('.disabledRegistration').on('click', function(e){
        customAlert('<p>Sorry, tickets are not available yet. Please wait for the official announcement. Thank you.</p>');
        e.preventDefault();
    });

    // faq
    $('.faq-menu').on('click', function(){
        $('.accordion').fadeOut();
        $('.faq-menu').removeClass('bd-callout-white');
        $(this).addClass('bd-callout-white');
        $($(this).data("target")).delay(300).fadeIn();
    });

    // smoothscroll
    $('.more').on('click', function(e){
        $('html, body').animate(
            {
            scrollTop: $($(this).attr('href')).offset().top + -80,
            },
            1000,
            'swing'
        )
    });

    // users
    $('.btnUpdatePassword').on('click', function(e){
        var a = $('input[name="password"]').val();
        var b = $('input[name="verifypassword"]').val();
        verifyPassword(a, b, e);
    });
    $('.choose-profile').on('click', function(){
        $('input[name="profilepic"]').trigger('click');
    });

    $('.change-profile').on('click', function(){
        $('.profile-pic').addClass('d-none');
        $('.crop-container').removeClass('d-none');
    });
    $('.cancel-profile').on('click', function(){
        $('.profile-pic').removeClass('d-none');
        $('.crop-container').addClass('d-none');
        $('input[name="profilepic"]').val('');
    });
    
    $('.print-window').click(function() {
        alert('sd');
        window.print();
    });

    function showLoading(){
        $('#loading').fadeIn();
    }
    $('.frm-show-loading').submit(function(){
        showLoading();
    });

    function updatedRow(row){
        row.addClass('updated');
        setTimeout(function() {
            row.removeClass("updated");
        }, 1000);
    }
    function hideLoading(){
        $('#loading').fadeout();
    }

    // custom file input
    $('body').on('change', '.custom-file-input', function(e){
        $(this).closest('.custom-file').find('.custom-file-label').html(e.target.files[0].name);
    });

    // 
    function initItems(){
        $('.pap-add-cart').removeClass('d-none');
        $('.pap-added').addClass('d-none');
    }
    $('.pap-add-cart').on('click', function(){
        initItems();
        $(this).addClass('d-none');
        $(this).closest('div').find('.pap-added').removeClass('d-none');
        $.ajax({
            type:'post',
            url:'/ajx-pap-add',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data:{
                'id' : $(this).data('id')
            },
            success:function(data){
                console.log(data)
            },
            error:function(data){
                console.log(data);
                alert('Error, please contact PAPJA Admin');
            }
        });
    });
    $('.pap-added').on('click', function(){ 
        initItems();
        $(this).addClass('d-none');
        $(this).closest('div').find('.pap-add-cart').removeClass('d-none');
        $.ajax({
            type:'post',
            url:'/ajx-pap-remove',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data:{
                'id' : $(this).data('id')
            },
            success:function(data){
                console.log(data)
            },
            error:function(data){
                console.log(data);
                alert('Error, please contact PAPJA Admin');
            }
        });
    });
    
    

    // on region select
    $('#sltRegion').on('change', function(){
        $('#sltProvince').find('.option').remove();
        $('#sltProvince option:first-child').prop('selected', true);
        $('#sltCity').find('.option').remove();
        $('#sltCity option:first-child').prop('selected', true);
        $('#sltCity').prop('disabled', true);
        $.ajax({
            type: 'post',
            url: '/ajx-get-provinces',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: {
                'region' : $(this).val()
            },
            success: function(data){
                let options = ``;
                $.each(data, function (i, v) {
                    // console.log(data)
                    options += `<option value="${data[i]['id']}" class="option">${data[i]['name']}`;
                });
                $('#sltProvince').append(options);
                $('#sltProvince').prop('disabled', false);
            },
            error: function(){
                alert('error: contact support');
            }
        });
    });
    // on province select
    $('#sltProvince').on('change', function(){
        if($(this).val() != ''){
            $('#sltCity').find('.option').remove();
            $('#sltCity option:first-child').prop('selected', true);
            $.ajax({
                type: 'post',
                url: '/ajx-get-cities',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: {
                    'province': $(this).val()
                },
                success: function(data){
                    let option = ``;
                    $.each(data, function(i, v){
                        option += `<option value="${data[i]['id']}" class="option">${data[i]['name']}</option>`;
                    });
                    $('#sltCity').append(option);
                    $('#sltCity').prop('disabled', false);
                },
                error: function(){
                    alert('error : contact support')
                }
            });
        }
    });
    $('#memberId').on('change', function(){
        alert('x');
    });
    $('.close-tab').on('click', function(){
        close();
    });
});
$(function(){
    $('#loading').fadeOut();
});








// test


